import React from 'react';
import env from 'env';
import { Table } from 'components/table/table';
import { useGet } from 'components';
import { SiteLink } from 'components';
import { Loading, ErrorPopup } from 'components';
import { formatDateTime } from 'lib/utils-core/dateExt'

export function ContactList(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        Cell: (c) => {
          //console.log(c)
          return (<SiteLink to={`/admin/contact/${c.row.original.contactId}`}><b>{c.cell.value}</b></SiteLink>)
        }
      },
      {
        Header: 'Email',
        accessor: 'email'
      },
      {
        Header: 'Status',
        accessor: 'contactStatus',
      },
      {
        Header: 'Site',
        accessor: 'siteCode'
      },
      {
        Header: 'Country',
        accessor: 'country',
      },
      {
        Header: 'Date Sent',
        accessor: 'dateSent',
        Cell: (c) => c.cell.value && formatDateTime(c.cell.value, 'yyyy-MM-dd HH:mm')
      }
    ],
    []
  )

  const [filterContactSite] = React.useState(window.localStorage.getItem('filterContactSite') || 'all');
  const [filterContactStatus, setFilterContactStatus] = React.useState(window.localStorage.getItem('filterContactStatus') || 'all');
  const [filterKeyword, setFilterKeyword] = React.useState(window.localStorage.getItem('filterContactKeyword') || '');
  const get = useGet();

  React.useEffect(() => {
    get.send(env.apiBase + '/api/contactAdmin/getContacts?site=' + filterContactSite + '&status=' + filterContactStatus);
    // eslint-disable-next-line
  }, [filterContactSite, filterContactStatus]);

  if (get.loading()) {
    return <Loading />
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  // const changeFilterContactSite = (e) => {
  //   setFilterContactSite(e.target.value)
  //   window.localStorage.setItem('filterContactSite', e.target.value);
  // }

  const changeFilterContactStatus = (e) => {
    setFilterContactStatus(e.target.value)
    window.localStorage.setItem('filterContactStatus', e.target.value);
  }

  const changeFilterKeyword = (e) => {
    setFilterKeyword(e.target.value)
    window.localStorage.setItem('filterContactKeyword', e.target.value);
  }

  function filterList(data) {
    let filtered = data;
    if (filterKeyword) {
      filtered = filtered.filter(x => searchInField(x.name, filterKeyword) ||
        searchInField(x.email, filterKeyword))
    }
    return filtered;
  }

  function searchInField(str, search_str) {
    if (!str || !search_str) return false;
    const result = str.search(new RegExp(escapeRegExp(search_str), "i"));
    return result >= 0
  }

  function escapeRegExp(str) {
    // eslint-disable-next-line
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  }

  function removeFilter() {
    setFilterKeyword('')
    window.localStorage.setItem('filterKeyword', '');
  }

  //  console.log(get)
  const data = get.response;
  const filtered = filterList(data);
  //console.log(filtered)

  return (
    <>
      <h1>Contacts</h1>
      <div className="filter" style={{ minHeight: '30px' }}>
        <div style={{ float: 'right', display: 'flex', alignItems: 'center' }}>

          {/* <select name="site" type="select" className="form-control" value={filterContactSite} onChange={changeFilterContactSite} style={{marginRight:'10px'}}>
            <option value="all">All Sites</option>
            <option value="vssassoon-au">Women - AU</option>
            <option value="vsmen-au">Men - AU</option>
            <option value="vssassoon-nz">Women - NZ</option>
            <option value="vsmen-nz">Men - NZ</option>
          </select> */}

          <select name="status" type="select" className="form-control" value={filterContactStatus} onChange={changeFilterContactStatus} style={{ marginRight: '10px' }}>
            <option value="all">All Status</option>
            <option value="Received">Received</option>
            <option value="Processed">Processed</option>
          </select>
          <input className="form-control" type="text" placeholder="Search" value={filterKeyword} onChange={changeFilterKeyword} />
          {filterKeyword && <span style={{ display: 'inlne-block', fontSize: '0.8rem', color: 'chocolate', marginLeft: '10px', cursor: 'pointer' }} onClick={removeFilter}>clear filter</span>}
        </div>

      </div>
      <Table columns={columns} data={filtered} />
    </>
  );
}
